export default {
      id: "auto-white-usage",
      viewBox: "0 0 197 24",
      url: __webpack_public_path__ + "sprite.svg#auto-white-usage",
      toString: function () {
        return this.url;
      }
    }